import './../fonts/proximanova.css';
import { globalNocowanieStyles } from './global-nocowanie.styles';

export const globalCss = {
    html: {
        fontFamily: '"Proxima Nova", Arial, sans-serif',
        color: '{colors.bodyText}',
        colorPalette: 'secondary',
    },
    ...globalNocowanieStyles,
};
